import { render } from "./Academics.vue?vue&type=template&id=3c902abc&ts=true"
import script from "./Academics.vue?vue&type=script&lang=ts"
export * from "./Academics.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/vmchs.frontend/vmchs.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__